import { createReducer } from 'deox';
import { FeatureItems } from '@/types';
import { getFeatureItemsActions } from '@/redux/actions/service-directory';

export interface FeatureItemsState {
  data?: FeatureItems;
}

const initialState: FeatureItemsState = {
  data: undefined,
};

const featureItemsReducer = createReducer(initialState, (handleAction) => [
  handleAction(getFeatureItemsActions.success, (state, { payload }) => {
    return {
      ...state,
      data: payload,
    };
  }),
]);

export default featureItemsReducer;
